import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './ConsignmentForm.css';

const CreateStaff = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [hubs, setHubs] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedHub, setSelectedHub] = useState('');
  const [selectedBranch, setSelectedBranch] = useState('');
  const [role, setRole] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch all hubs
    const fetchHubs = async () => {
      try {
        const response = await axios.get('https://kartikenterprisesindia.co.in/api/users/hub');
        setHubs(response.data);
      } catch (err) {
        setError('Failed to fetch hubs');
      }
    };
    fetchHubs();
  }, []);

  const handleHubChange = async (hubId) => {
    setSelectedHub(hubId);
    setSelectedBranch(''); // Reset branch dropdown

    // Fetch branches for the selected hub
    try {
      const response = await axios.get(`https://kartikenterprisesindia.co.in/api/users/branch?hub=${hubId}`);
      setBranches(response.data);
    } catch (err) {
      setError('Failed to fetch branches for the selected hub');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = document.cookie.split('; ').find(row => row.startsWith('auth_token='));
    const userId = token ? JSON.parse(atob(token.split('=')[1].split('.')[1])).userId : null;

    try {
      const response = await axios.post('https://kartikenterprisesindia.co.in/api/users/staff', {
        username,
        password,
        hub: selectedHub,
        branch: selectedBranch,
        role,
        userId,
      });
      if (response.status === 201) {
        alert("Staff registered successfully");
      }
    } catch (error) {
      alert(error.response?.data?.error || "Failed to register Staff");
      console.error(error);
    }
  };


  return (
    <div>
      <h2>Create Staff</h2>
      {error && <div className="error">{error}</div>}
      <form onSubmit={handleSubmit}>
      <div className="row">
      <div className="column50">
          <label>Username:</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="column50">
          <label>Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        </div>
        <div className="row">
        <div className="column30">
          <label>Hub:</label>
          <select value={selectedHub} onChange={(e) => handleHubChange(e.target.value)} required>
            <option value="">Select Hub</option>
            {hubs.map((hub) => (
              <option key={hub._id} value={hub._id}>
                {hub.code}
              </option>
            ))}
          </select>
        </div>
        <div className="column30">
          <label>Branch:</label>
          <select value={selectedBranch} onChange={(e) => setSelectedBranch(e.target.value)} required>
            <option value="">Select Branch</option>
            {branches.map((branch) => (
              <option key={branch._id} value={branch._id}>
                {branch.code}
              </option>
            ))}
          </select>
        </div>
        <div className="column30">
          <label>Role:</label>
          <select value={role} onChange={(e) => setRole(e.target.value)} required>
            <option value="">Select Role</option>
            <option value="STAFF">STAFF</option>
            <option value="DRIVER">DRIVER</option>
          </select>
        </div>
        </div>
        <button type="submit"  style={{backgroundColor:'blue'}}>Create Staff</button>
      </form>
    </div>
  );
};

export default CreateStaff;
